import { render, staticRenderFns } from "./prediccionesEnviadas.vue?vue&type=template&id=b352cdf4&"
import script from "./prediccionesEnviadas.vue?vue&type=script&lang=js&"
export * from "./prediccionesEnviadas.vue?vue&type=script&lang=js&"
import style0 from "./prediccionesEnviadas.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports